import { useMemo } from "react";
import { useAuth } from "hooks/useAuth";

/**
 * Hook to filter a list of objects by current group.
 * It keeps only the elements whose `groupId` field
 * matches the group of the user (first element of companyList).
 *
 * @param {Array} itemsList - List of objects to filter (must contain a `groupId` field)
 * @returns {Array} Filtered list of objects
 */
export const useFilterByCurrentGroup = (itemsList) => {
  const { companyList } = useAuth();

  return useMemo(() => {
    if (
      !Array.isArray(itemsList) ||
      !Array.isArray(companyList) ||
      companyList.length === 0
    ) {
      return itemsList || [];
    }

    const currentGroupId = companyList[0]?.id;

    if (!currentGroupId) {
      return itemsList;
    }

    return itemsList.filter((item) => item?.groupId === currentGroupId);
  }, [itemsList, companyList]);
};
